export default __webpack_public_path__ + "static/media/Claw of the Vaaghasan.6140a5bf.jpg";